module.exports = __webpack_public_path__ + "assets/textures/violin_tex_metalness.63904e59f9e6a580c7444a468f13fb43.jpg";